
// [stiffness, damping]
"use strict";

exports.__esModule = true;
exports["default"] = {
  noWobble: [170, 26], // the default
  gentle: [120, 14],
  wobbly: [180, 12],
  stiff: [210, 20]
};
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-motion/lib/presets.js
 ** module id = 875
 ** module chunks = 0
 **/